module.exports = __webpack_public_path__ + "static/media/icon-support.07a504e6.svg";